import React from 'react';
import { Modal } from '../../components/common/modal';
import IndividualPropertyVideos from './individual_property_videos';

import { 
    IPortalPropertyAsset
 } from '../../interfaces/asset';
import { IPortalScoreItem } from '../../interfaces/property';

interface IProps {
    handleClose(): void;
    handleReloadPropertyVideos: (nhID: number[], profileCompletenessState: IPortalScoreItem, profileCompletenessFilterValue: boolean | null, orgNHID?: number) => Promise<IPortalPropertyAsset[]>;
    orgNHID: number | null;
    nhIDs: number[];
    selNHID: number | null;
    propertyVideos: IPortalPropertyAsset[];
    setPropertyVideos: (propertyVideos: IPortalPropertyAsset[]) => void;
    busyLoadingAsset: boolean;
    setBusyLoadingAsset: (busyState: boolean) => void;
    profileCompletenessFilterValue: boolean | null;
}

const VideoUploadModal = ({
    handleClose,
    handleReloadPropertyVideos,
    orgNHID,
    nhIDs,
    selNHID,
    propertyVideos,
    setPropertyVideos,
    busyLoadingAsset,
    setBusyLoadingAsset,
    profileCompletenessFilterValue
}: IProps) => {

    const propertyName = (propertyVideos || []).length > 0 ? propertyVideos[0].Property.Name : '';

    return (
        <>
            <Modal
                isOpen={true}
                onClose={handleClose}
                title='Upload a New Video'
                subTitle={propertyName}
                size='xl'
            >
                <IndividualPropertyVideos
                    handleReloadPropertyVideos={handleReloadPropertyVideos}
                    profileCompletenessFilterValue={profileCompletenessFilterValue}
                    orgNHID={orgNHID}
                    nhIDs={nhIDs}
                    selNHID={selNHID}
                    propertyVideos={propertyVideos}
                    setPropertyVideos={setPropertyVideos}
                    busyLoadingAsset={busyLoadingAsset}
                    setBusyLoadingAsset={setBusyLoadingAsset}
                    handleClose={handleClose}
                />
            </Modal>
        </>
    );
};

export default VideoUploadModal;